import React from 'react';
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import {
  MeetingRoomBookingViewPanel,
  removeAttendee,
  selectAttendees,
  selectOverriddenMeetingHost,
  selectVisitors,
  setDialogPanel,
  setOverriddenMeetingHost
} from "../../models/meeting-room-booking-dialog.duck";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { BasicUserInfo } from '@shared/models/user.models';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { ToggleableOutlineButton } from '@shared/ui/atoms/buttons/ToggleableOutlineButton';
import { UserInfoRow, VisitorAttendeeRow } from "./VisitorAttendeeRow";
import { VisitorBooking } from "../../../../components/pages/company-movements/components/visitor-booking/data/visitor-booking-service";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function MeetingRoomBookingTabAttendeesView(props: Props) {
  const attendees = useSelector(selectAttendees);
  const visitors = useSelector(selectVisitors);
  const overriddenMeetingHost = useSelector(selectOverriddenMeetingHost);
  const dispatch = useDispatch();
  const onAddAttendeesClicked = () => {
    if (props.userCanSaveBooking) {
      dispatch(setDialogPanel(MeetingRoomBookingViewPanel.AddRemoveAttendees));
    }
  }
  const onAddVisitorClicked = () => {
    if (props.userCanSaveBooking) {
      dispatch(setDialogPanel(MeetingRoomBookingViewPanel.AddRemoveVisitors));
    }
  }
  const onRemoveUserClicked = (user: BasicUserInfo) => {
    if (props.userCanSaveBooking) {
      dispatch(removeAttendee(user));
    }
  }
  const onMakeHostButtonClicked = (host: BasicUserInfo) => {
    if (props.userCanSaveBooking) {
      if (overriddenMeetingHost?.userId === host.userId) {
        dispatch(setOverriddenMeetingHost(undefined));
      } else {
        dispatch(setOverriddenMeetingHost(host));
      }
    }
  }
  return (
    <Container>
      <AttendeesList>
        {attendees.map((user: BasicUserInfo, key: number) => (<UserInfoRow key={key}>
          <UserAvatarAndName colour={'darkBlue'} firstName={user.firstName} lastName={user.lastName} jobTitle={user.email} style={{width: '100%'}} />
          <ToggleableOutlineButton isActive={overriddenMeetingHost?.userId === user.userId}
                                   hideBorder={false}
                                   text={'Make host'}
                                   size={ButtonSize.Small}
                                   disabled={!props.userCanSaveBooking}
                                   click={() => onMakeHostButtonClicked(user)} />
          <IconButton disabled={!props.userCanSaveBooking}
                      icon={IconTypes.Bin}
                      onClick={() => onRemoveUserClicked(user)} />
        </UserInfoRow>))}
        {visitors.map((visitor: VisitorBooking, key: number) => (<VisitorAttendeeRow key={key} userCanSaveBooking={props.userCanSaveBooking} visitor={visitor} />))}
      </AttendeesList>
      <Controls>
        <OutlineButton click={onAddAttendeesClicked}
                       disabled={!props.userCanSaveBooking}
                       text={'Add Attendee'}
                       size={ButtonSize.Small} />
        <OutlineButton click={onAddVisitorClicked}
                       disabled={!props.userCanSaveBooking}
                       text={'Add Visitor'}
                       size={ButtonSize.Small} />
      </Controls>
    </Container>
  )
}

interface Props {
  userCanSaveBooking: boolean;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

const AttendeesList = styled.div`
  height: 280px;
  overflow-y: auto;
`

const Controls = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 12px;
  padding-top: 16px;
  button:first-child {
     margin-right: 8px;
  }
  button:last-child {
     margin-left: 8px;
  }
`
